module.exports = __webpack_public_path__ + "static/img/shuziyingxiao_06.880769ff.jpg";